import { CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Button, Input, message, Modal, Spin, Typography } from "antd";
import { useEffect, useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import { createInformation, getInformation, updateInformation } from "src/services/information.service";
import { profileStore } from "src/stores/profile-store";
import { useShallow } from "zustand/react/shallow";
import { InformationPayload } from "src/entity/information/information.entity";
import { CommonError, CommonSuccess } from "src/entity/common/menus-enum.enum";
import { blackListGlobalCommentsInformation } from "src/entity/common/common.constant";

const { Text } = Typography;

const Information = (props: { path: string }) => {
  const { path } = props;
  const [title, setTitle] = useState<string>("");
  const [companyId, setCompanyId] = useState<string>("");
  const [isSystemAdmin, setIsSytemAdmin] = useState<boolean>(false);
  const profile = profileStore(useShallow((state) => state.profile));
  const [isOpenDescription, setIsOpenDescription] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [mode, setMode] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [messageApi, contextHolder] = message.useMessage();

  const intitalData = () => {
    if (profile?.activeCompany?._id) {
      setCompanyId(profile.activeCompany._id);
    }

    if (profile?.isSystemAdmin) {
      setIsSytemAdmin(profile?.isSystemAdmin);
    }
  };

  const onCloseModal = () => {
    setIsOpenDescription(false);
    setIsEdit(false);
  };

  const onChangeInformation = (value: string) => {
    setDescription(value);
  };

  const onChangeTitle = (value: string) => {
    setTitle(value);
  };

  const fetchInfomation = async () => {
    try {
      if (companyId && path) {
        const finalCompanyId = blackListGlobalCommentsInformation.find((item) => item === path);
        const query = {
          path,
          companyId: finalCompanyId ? null : companyId,
        };
        const response = await getInformation(query);
        if (response.data.code === 200) {
          if (response.data.data?.length > 0) {
            const data = response.data.data[0];
            setDescription(data?.description);
            setTitle(data?.title);
            setMode("update");
          } else {
            setMode("insert");
            setTitle("");
            setDescription("");
          }
        }
      }
    } catch (error) {
      setMode("insert");
      setTitle("");
      setDescription("");
      console.error(error);
    }
  };

  const saveInformation = async () => {
    try {
      setLoading(true);
      let response;
      let payload: InformationPayload = {
        title: title,
        description: description,
        path: path,
      };
      const finalCompanyId = blackListGlobalCommentsInformation.find((item) => item === path);

      if (mode == "insert") {
        payload = {
          ...payload,
          companyId: finalCompanyId ? null : companyId,
        };
        response = await createInformation([payload]);
      } else if (mode == "update") {
        response = await updateInformation({ ...payload, companyId: finalCompanyId ? null : companyId });
      }
      if (response && response.data.code === 200) {
        messageApi.open({
          type: "success",
          content: CommonSuccess.SAVED_SUCCESSFULL,
        });
      } else {
        messageApi.open({
          type: "error",
          content: CommonError.SOMETHING_WRONG,
        });
      }
    } catch (error) {
      messageApi.open({
        type: "error",
        content: CommonError.SOMETHING_WRONG,
      });
    } finally {
      setLoading(false);
      onCloseModal();
    }
  };

  useEffect(() => {
    intitalData();
  }, [profile?.activeCompany, profile?.isSystemAdmin]);

  useEffect(() => {
    setIsEdit(false);
    fetchInfomation();
  }, [companyId, path]);

  return (
    <>
      {contextHolder}
      <Modal
        title={
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <InfoCircleOutlined style={{ marginRight: 8, color: "#1890FF" }} />

              {isEdit ? <Input value={title} onChange={(e) => onChangeTitle(e.target.value)} /> : <>{title}</>}
            </div>
            <div>
              {isSystemAdmin && <Button type="text" icon={<FaRegEdit />} onClick={() => setIsEdit(true)} />}
              <Button type="text" icon={<CloseOutlined />} onClick={() => onCloseModal()} />
            </div>
          </div>
        }
        open={isOpenDescription}
        onCancel={() => setIsOpenDescription(false)}
        footer={null}
        closeIcon={null}
        centered
      >
        {isEdit ? (
          <>
            <Input.TextArea value={description} onChange={(e) => onChangeInformation(e.target.value)} rows={4} />
            <div style={{ display: "flex", justifyContent: "end", paddingTop: "20px" }}>
              <Button type="primary" onClick={() => saveInformation()} loading={loading}>
                Save
              </Button>
            </div>
          </>
        ) : (
          <Text style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>{description}</Text>
        )}
      </Modal>
      <Button
        type="text"
        icon={<InfoCircleOutlined style={{ fontSize: "25px", color: "#9D9C9B" }} onClick={() => setIsOpenDescription(true)} />}
      />
    </>
  );
};

export default Information;
